import { Modal, ModalCallToAction, Spinner } from '@platform/components';
import { GreenCircleCheckmark } from '../svg/GreenCircleCheckmark';

export type ModalStage = 'form' | 'submitting' | 'error' | 'success';

/** A very basic 4 step modal for simple admin record updates */
export const AdminFormModal = (props: {
  modalStage: ModalStage;
  title: string;
  onClose: () => void;
  submitCTA: ModalCallToAction;
  children: React.ReactNode;
  variant?: 'dialog' | 'full-screen';
  successText?: string;
  errorText?: string;
}) => {
  const { modalStage, title, onClose, submitCTA, children, variant } = props;
  const primaryCTA: ModalCallToAction =
    modalStage === 'form' ? submitCTA : (
      {
        buttonVariant: 'primary',
        text: 'Close',
        callback: props.onClose,
        isDisabled: () => modalStage === 'submitting',
      }
    );
  const secondaryCTA: ModalCallToAction = {
    text: 'Cancel',
    callback: props.onClose,
  };
  return (
    <Modal
      headerDivision='divider'
      variant={variant ?? 'dialog'}
      isOpen={true}
      onClose={onClose}
      title={title}
      primaryCTA={primaryCTA}
      secondaryCTA={modalStage === 'form' ? secondaryCTA : undefined}
      ignoreExtraPadding
    >
      <div className='min-w-[350px]'>
        {modalStage === 'form' && <div>{children}</div>}
        {modalStage === 'submitting' && <ModalSubmittingContent />}
        {modalStage === 'error' && <ModalErrorContent errorText={props.errorText} />}
        {modalStage === 'success' && <ModalSuccessContent successText={props.successText} />}
      </div>
    </Modal>
  );
};

const ModalErrorContent = (props: { errorText?: string }) => {
  return (
    <div className='flex flex-col items-center justify-center'>
      <p>Error updating record.</p>
      <p>{props.errorText ?? 'Try again later or contact support.'}</p>
    </div>
  );
};

const ModalSuccessContent = (props: { successText?: string }) => {
  return (
    <div className='flex flex-col items-center justify-center'>
      <GreenCircleCheckmark />
      <span>{props.successText ?? 'Record updated!'}</span>
    </div>
  );
};

const ModalSubmittingContent = () => {
  return (
    <div className='flex flex-col items-center justify-center'>
      <Spinner />
      <span>Submitting...</span>
    </div>
  );
};
